import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", null, "Referentienummer", -1)
const _hoisted_3 = { class: "no-mb" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Onderwerp", -1)
const _hoisted_5 = { class: "no-mb" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", null, "Omschrijving", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld door", -1)
const _hoisted_9 = { class: "no-mb" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Gesteld op", -1)
const _hoisted_11 = { class: "no-mb" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", null, "Aangeleverde bestanden", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, "Deze melding wordt binnen 5 dagen automatisch gesloten. Mocht u het niet eens zijn met de afhandeling van uw klacht, dan kunt u dit via onderstaande knop, binnen 5 dagen, aangeven.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "no-mb" }, "Omschrijf hieronder waarom u niet akkoord bent met de afhandeling van uw klacht.", -1)
const _hoisted_15 = { key: 3 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Referentienummer", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "Gemeld door", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Gemeld op", -1)
const _hoisted_19 = { class: "no-mb" }

import { useRoute, useRouter } from 'vue-router'
import { issueStore } from '@/stores/issue'
import { computed, onMounted, onBeforeUnmount, ref } from 'vue'
import { IssueStatusColors } from '@/globalVariables'
import Filelist from '@/components/service/Filelist.vue'
import NewComment from '@/components/service/NewComment.vue'
import Comments from '@/components/service/Comments.vue'
import TextEditor from '@/components/service/TextEditor.vue'
import axios from 'axios'
import { authStore } from '@/stores/auth'
import { notification } from 'ant-design-vue'
import { generalStore } from '@/stores/general'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssueShow',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const showRejectModal = ref(false)
const rejectMessage = ref<string|null>(null)

const title = computed(() => {
  const issue = issueStore().issue
  if (issue) {
    return 'Servicemelding #' + issue.id + ' - ' + issue.title
  }

  return 'Servicemelding'
})

onMounted(() => {
  issueStore().getIssue(route.params.issueId)
})

onBeforeUnmount(() => {
  issueStore().issue = null
})

function toggleRejectModal () : void {
  showRejectModal.value = !showRejectModal.value
  rejectMessage.value = null
}

function rejectIssue () : void {
  axios.post(process.env.VUE_APP_API_URL + '/issues/' + route.params.issueId + '/rejected', {
    comment: {
      body: rejectMessage.value,
      user_id: authStore().user.id,
      shared_with_solver: true,
      shared_with_client: true
    },
    status: 5 // DISAGREED
  }).then(() => {
    issueStore().getIssue(route.params.issueId)
    toggleRejectModal()
    notification.success({
      message: 'Bericht opgeslagen.',
      description: 'Wij hebben uw bericht ontvangen. Wij komen zo snel mogelijk met een reactie bij u terug.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Bericht NIET opgeslagen.',
      description: 'Er is helaas iets mis gegaan. Probeer het later nog een keer.',
      duration: 0
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      (_unref(generalStore)().appSettings?.notification?.pages.includes('Service'))
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            span: 24
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_alert, {
                type: "info",
                class: "global-notification mb-16",
                message: _unref(generalStore)().appSettings.notification.title,
                "show-icon": ""
              }, {
                description: _withCtx(() => [
                  _createElementVNode("div", {
                    innerHTML: _unref(generalStore)().appSettings.notification.description
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 8, ["message"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_col, {
        xs: {span: 24},
        sm: {span: 24},
        md: {span: 24},
        lg: {span: 16}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    loading: !_unref(issueStore)().issue
                  }, _createSlots({
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(generalStore)().desktop ? _unref(title) : 'Servicemelding'), 1)
                    ]),
                    default: _withCtx(() => [
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_2,
                                  _createElementVNode("p", _hoisted_3, "#" + _toDisplayString(_unref(issueStore)().issue.id), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_4,
                              _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(issueStore)().issue.title), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { class: "no-mb" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _hoisted_6,
                              _createElementVNode("div", {
                                innerHTML: _unref(issueStore)().issue.body
                              }, null, 8, _hoisted_7)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_8,
                                  _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(issueStore)().issue.reported), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_10,
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(issueStore)().issue.created_at ? new Date(_unref(issueStore)().issue.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_unref(generalStore)().desktop && _unref(issueStore)().issue?.media.length)
                        ? (_openBlock(), _createBlock(_component_a_row, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_12,
                                  _createVNode(Filelist, {
                                    media: _unref(issueStore)().issue.media
                                  }, null, 8, ["media"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, [
                    (_unref(issueStore)().issue)
                      ? {
                          name: "extra",
                          fn: _withCtx(() => [
                            (_unref(generalStore)().desktop && _unref(route).name !== 'Global/IssueShow')
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Service' })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Terug naar service")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_unref(generalStore)().desktop && _unref(route).name === 'Global/IssueShow')
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'Global/Issues' })))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Terug naar overzicht")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_unref(generalStore)().desktop)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 2,
                                  color: _unref(IssueStatusColors)[_unref(issueStore)().issue.status.id]
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(issueStore)().issue.status.name), 1)
                                  ]),
                                  _: 1
                                }, 8, ["color"]))
                              : _createCommentVNode("", true)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1032, ["loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_unref(issueStore)().issue)
            ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        title: "Berichten",
                        bordered: false
                      }, {
                        default: _withCtx(() => [
                          (![2, 4, 15].includes(_unref(issueStore)().issue.status.id))
                            ? (_openBlock(), _createBlock(NewComment, {
                                key: 0,
                                "model-type": "issues",
                                "model-id": _unref(route).params.issueId,
                                onCommentCreated: _cache[2] || (_cache[2] = ($event: any) => (_unref(issueStore)().getIssue(_unref(route).params.issueId)))
                              }, null, 8, ["model-id"]))
                            : ([2, 15].includes(_unref(issueStore)().issue.status.id))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _hoisted_13,
                                  _createVNode(_component_a_button, { onClick: toggleRejectModal }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Niet akkoord")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_divider),
                                  _createVNode(_component_a_modal, {
                                    title: "Niet akkoord met oplossing.",
                                    visible: showRejectModal.value,
                                    width: 600,
                                    "ok-text": "Versturen",
                                    onOk: rejectIssue,
                                    onCancel: toggleRejectModal
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _hoisted_14
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_row, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _createVNode(TextEditor, {
                                                content: rejectMessage.value,
                                                onContentChange: _cache[3] || (_cache[3] = ($event: any) => (rejectMessage.value = $event))
                                              }, null, 8, ["content"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["visible"])
                                ], 64))
                              : _createCommentVNode("", true),
                          (_unref(issueStore)().issue.comments.length)
                            ? (_openBlock(), _createBlock(Comments, {
                                key: 2,
                                comments: _unref(issueStore)().issue.comments
                              }, null, 8, ["comments"]))
                            : (_openBlock(), _createElementBlock("p", _hoisted_15, "Geen berichten."))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_unref(issueStore)().issue && _unref(generalStore)().desktop)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 1,
            span: 8
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 24 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, { title: "Details" }, {
                        extra: _withCtx(() => [
                          _createVNode(_component_a_tag, {
                            color: _unref(IssueStatusColors)[_unref(issueStore)().issue.status.id]
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(issueStore)().issue.status.name), 1)
                            ]),
                            _: 1
                          }, 8, ["color"])
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { class: "no-mb" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_16,
                                  _createElementVNode("p", null, "#" + _toDisplayString(_unref(issueStore)().issue.id), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_17,
                                  _createElementVNode("p", null, _toDisplayString(_unref(issueStore)().issue.reported), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _hoisted_18,
                                  _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(issueStore)().issue.created_at ? new Date(_unref(issueStore)().issue.created_at).toLocaleDateString('nl-NL') : '-'), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_unref(issueStore)().issue.media.length)
                ? (_openBlock(), _createBlock(_component_a_row, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, { title: "Aangeleverde bestanden" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { class: "no-mb" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(Filelist, {
                                        media: _unref(issueStore)().issue.media
                                      }, null, 8, ["media"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})